var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-planningList-monthly-more",
    transform: "translate(-922.000000, -522.000000)",
    stroke: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(923.000000, 522.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L0,10",
    id: "Stroke-449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 L0,0",
    id: "Stroke-450"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/icClose.4104cc008f145ddf38b0107ce4457cac.svg";
export { ForwardRef as ReactComponent };